export default __webpack_public_path__ + "static/media/h5-section1-bg2.7cb823ed.png";